 <template>
        <div v-loading="loading" style="width:100%;background-color:rgba(0,0,0,0.05);display: flex;flex-direction: column;align-items: center;justify-content: center;">
            <div v-if="newsTitle.length>0" style="width:1200px;background-color: #ffffff;margin:10px 0;">
                <div style="height:50px;border-bottom: 1px dashed #2d8cf0;line-height: 50px;color:#2d8cf0;font-size: 14px;padding: 0 16px;">
                    {{newsTitle}}
                </div>
                <div v-if="vHtml" id="wordView" v-html="vHtml" style="padding: 16px;width:100%;box-sizing: border-box;"></div>
                <div v-if="showFile" style="border-top: 1px dashed #2d8cf0;padding-top:20px;padding-left: 30px;">
                    <div style="font-size: 20px;color:#515a61;font-weight: bold;">附件下载:</div>
                    <div style="display: flex;justify-content:space-around;flex-direction: column;align-items: left;font: bold 16px arial, sans-serif;color:#2d8cf0;height: 200px;">
                        <div v-for="item in fileArr" :key="item.name" >
                            <i class="el-icon-link"></i><a target="_blank" :href="item.url" style="color: #2d8cf0;background: transparent;text-decoration: none;outline: none;cursor: pointer;">{{item.name}}</a>
                        </div>                       
                        <!-- <div><i class="el-icon-link"></i><a target="_blank" href="uploadFiles/News/附件2：西安美术学院2024年公开招聘专任教师岗位报名登记表.docx" style="color: #2d8cf0;background: transparent;text-decoration: none;outline: none;cursor: pointer;">附件2：西安美术学院2024年公开招聘专任教师岗位报名登记表</a></div>
                        <div><i class="el-icon-link"></i><a target="_blank" href="uploadFiles/News/附件3：西安美术学院2024年公开招聘辅导员岗位报名登记表.docx" style="color: #2d8cf0;background: transparent;text-decoration: none;outline: none;cursor: pointer;">附件3：西安美术学院2024年公开招聘辅导员岗位报名登记表</a></div>
                        <div><i class="el-icon-link"></i><a target="_blank" href="uploadFiles/News/附件4：西安美术学院2024年公开招聘非教师技术岗位报名登记表.docx" style="color: #2d8cf0;background: transparent;text-decoration: none;outline: none;cursor: pointer;">附件4：西安美术学院2024年公开招聘非教师技术岗位报名登记表</a></div>
                        <div><i class="el-icon-link"></i><a target="_blank" href="uploadFiles/News/附件5：西安美术学院2024年公开招聘管理岗位报名登记表.docx" style="color: #2d8cf0;background: transparent;text-decoration: none;outline: none;cursor: pointer;">附件5：西安美术学院2024年公开招聘管理岗位报名登记表</a></div> -->
                        
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
    import mammoth from 'mammoth';
    export default{
        data(){
            return{
                vHtml:'',
                newsTitle:'',
                //wordURL:'http://localhost:8082/uploadFiles/Other/111.docx',
                wordURL:'',
                loading:true,
                showFile:false,
                fileArr:[],
            }
        },
        methods:{
            // perview(){
            //     var rowurl=this.wordURL;
            //     const typeArr = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx']
            //     let arr=rowurl.split('.')
            //     let fileType=arr[arr.length-1]
            //     let url = ''
            //     if (typeArr.indexOf(fileType) !== -1) {
            //         // 使用微软的office online
            //         url='http://view.xdocin.com/xdoc?_xdoc='+rowurl
            //     } else {
            //         url = rowurl
            //     }
            //     // window.open()居中打开
            //     const width = 1000; const height = 800
            //     const top = (window.screen.availHeight - height) / 2
            //     const left = (window.screen.availWidth - width) / 2
            //     window.open(url, '', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left)
            // },
            // readExcelFromRemoteFile: function (url) {
            //     var vm = this;
            //     var xhr = new XMLHttpRequest();
            //     xhr.open("get", url, true);
            //     xhr.responseType = "arraybuffer";
            //     xhr.onload = function () {
            //         if (xhr.status == 200) {
            //         mammoth
            //             .convertToHtml({ arrayBuffer: new Uint8Array(xhr.response) })
            //             .then(function (resultObject) {
            //             vm.$nextTick(() => {
            //                 // document.querySelector("#wordView").innerHTML =
            //                 //   resultObject.value;
            //                 vm.vHtml = resultObject.value;
            //             });
            //             });
            //         }
            //     };
            //     xhr.send();
            // },
            getDataList:function(newsId){
                var that = this;
                this.$axios.get(this.Global.globalUrl+'/interface/getNews.ashx'
                    ,{params:{
                        newsId:newsId
                    }}
                    ).then((res) => {
                    that.vHtml=res.data.newsContent;
                    that.newsTitle=res.data.newsTitle;
                    that.fileArr=res.data.fileArr;
                    if (res.data.showFile=="1"){
                        that.showFile=true;
                    }else{
                        that.showFile=false;
                    }
                    })
                    .catch(() => {
                    })
                    .finally(()=>{
                        this.loading=false;
                    })

            },

        },
        mounted(){
            this.$router.onReady(() => {
            
            if(this.$route.query.newsId != undefined && this.$route.query.newsId != null){
                console.log(this.$route.query.newsId);
                this.getDataList(this.$route.query.newsId);

            }
            })

        },
        created(){
          //  this.readExcelFromRemoteFile(this.wordURL);
//this.perview();
        }
    }
</script>